/** @format */

import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import {
	homefieldIconDeleteFilled,
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconStarFilled0Percent
} from '@dsg-tech/homefield-angular-icons';

import { HmfButtonComponent, HmfSkeletonComponent } from '@dsg-tech/homefield-angular';
import { BreakpointsService } from '@shared/data-access/services';
import { BreakPointNew } from '@shared/data-access/enums';

@Component({
	selector: 'compare-components-skeleton-compare-grid-product-card',
	imports: [HmfButtonComponent, HomefieldIconLibraryModule, HmfSkeletonComponent],
	templateUrl: './skeleton-compare-grid-product-card.component.html',
	styleUrl: './skeleton-compare-grid-product-card.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonCompareGridProductCardComponent {
	protected readonly breakpointsService = inject(BreakpointsService);

	readonly isCompact = input.required<boolean>();

	protected readonly BreakPointNew = BreakPointNew;

	constructor(private readonly hmfIconService: HomefieldIconsLibraryService) {
		this.hmfIconService.registerIcons([
			homefieldIconStarFilled0Percent,
			homefieldIconDeleteFilled
		]);
	}
}
